import { useRef, useState } from 'react';
import Menu from '@mui/material/Menu';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import type { MenuItemType } from './CustomContextMenuContainer.tsx';
import ContextMenuItem from './ContextMenuItem.tsx';

export type ContextMenuItemProps = {
  options: MenuItemType[];
  handleClick: (e: React.MouseEvent<HTMLElement>, callback: () => void) => void;
};

export type SubmenuItemProps = {
  item: Extract<MenuItemType, { type: 'submenu' }>;
  handleClick: (e: React.MouseEvent<HTMLElement>, callback: () => void) => void;
};

export const ContextMenuSubmenuItem = ({ item, handleClick }: SubmenuItemProps) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLLIElement>(null);

  return (
    <MenuItem
      ref={anchorRef}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      sx={{ minWidth: '170px', justifyContent: 'flex-start' }}
    >
      {item.actionIcon && (
        <Box component="div" display="flex" marginRight={'12px'} alignItems="center" justifyContent="center">
          {item.actionIcon}
        </Box>
      )}
      {item.title}
      <ChevronRightIcon sx={{ marginLeft: 'auto' }} fontSize="small" />
      <Menu
        open={open}
        anchorEl={anchorRef.current}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        onClose={() => setOpen(false)}
        sx={{ pointerEvents: 'none' }}
        PaperProps={{ sx: { pointerEvents: 'auto' } }}
      >
        <ContextMenuItem options={item.children} handleClick={handleClick} />
      </Menu>
    </MenuItem>
  );
};
